import classNames from 'classnames';
import React from 'react';
import { Icon } from '@fasstech/middle-design-system';

const ComplianceTag = ({
  pricingIsMinimumCcn,
  pricingIndex,
  minimumCCNIndex,
  isDisplayed
}) => {
  if (pricingIsMinimumCcn || !isDisplayed) {
    return null;
  }

  const offerIsCompliant = pricingIndex >= minimumCCNIndex && minimumCCNIndex > -1;

  return <div className="absolute -top-18 flex flex-col items-center w-full">
    <div
      className={classNames(
        'flex items-center text-center justify-center gap-2 rounded-lg bg-white border-2 text-sm font-bold p-1',
        {
          'text-red-600 border-red-600': !offerIsCompliant,
          'text-[#4ED64B] border-[#4ED64B]': offerIsCompliant
        }
      )}>

      {offerIsCompliant ? <>
        <Icon name="check" strokeClassName="stroke-[#4ED64B]" />
        Conforme à la CCN
      </> : <>
        Non conforme à la CCN
      </>}
    </div>
  </div>;
};

export default ComplianceTag;
